import { takeLatest, put, call } from 'redux-saga/effects';

import { listPatrimonioManutencaoCadastro } from '../service';
import {
  TABLE_PATRIMONIO_MANUTENCAO_CADASTRO,
  TABLE_PATRIMONIO_MANUTENCAO_CADASTRO_PENDING,
  TABLE_PATRIMONIO_MANUTENCAO_CADASTRO_SUCCESS,
  TABLE_PATRIMONIO_MANUTENCAO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListPatrimonioManutencaoCadastro(action) {
  yield put({ type: TABLE_PATRIMONIO_MANUTENCAO_CADASTRO_PENDING })

  try {
    const table = yield call(listPatrimonioManutencaoCadastro, action.args)
    yield put({ type: TABLE_PATRIMONIO_MANUTENCAO_CADASTRO_SUCCESS, table: table })
  } catch (error) {
    yield put({ type: TABLE_PATRIMONIO_MANUTENCAO_CADASTRO_FAILURE })
  }
}

export default function* watchListPatrimonioManutencaoCadastro() {
  yield takeLatest(TABLE_PATRIMONIO_MANUTENCAO_CADASTRO, sagaListPatrimonioManutencaoCadastro)
}
